import UtilisationEmailControls from '../../components/UtilisationEmailControls';
import React from "react";
import { Box, Button, Paper, Stack, Tab, Tabs } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/Layout";
import AddEventDialog from "./AddEventDialog";
import UtilisationDashboard from "../Dashboard/UtilisationDashboard";

export default function EventDetailsPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [tab, setTab] = React.useState(0);

    return (
        <Layout appBarTitle="Event Details">
            <Stack spacing={2}>
                <Button startIcon={<ArrowBackIcon />} onClick={() => navigate("/event")} sx={{ alignSelf: "flex-start" }}>
                    Back
                </Button>
                <Paper variant="outlined" sx={{ borderRadius: 3 }}>
                    <Tabs value={tab} onChange={(_, value) => setTab(value)} aria-label="event page sections" sx={{ px: 2 }}>
                        <Tab label="Dashboard" />
                        <Tab label="Event setup" />
                    </Tabs>
                </Paper>
                {id ? (
                    <Stack spacing={2} sx={{ display: tab === 0 ? "flex" : "none" }}>
                        <Box><UtilisationEmailControls source="events" filters={{ eventId: id }} /></Box>
                        <UtilisationDashboard key={id} eventId={id} />
                    </Stack>
                ) : null}
                <Box sx={{ display: tab === 1 ? "block" : "none" }}>
                    <AddEventDialog
                        asPage
                        isModalOpen
                        selectedId={id}
                        toggleModal={() => navigate("/event")}
                    />
                </Box>
            </Stack>
        </Layout>
    );
}
